
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class YeniUyelikAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KisiUyelikSave";
    super(baseUrl);
  }


  saveYeniUyelikSave(request: KisiUyelikSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new YeniUyelikAPI();


class KisiUyelikSaveRequest {
    uyelikTipi: number;
    uyrukKodu?: string;
    uyelikKodu?: string;
    tcKimlikNo?: string;
    vergiNo?: string;
    vergiDairesiAdi?: string;
    dogumTarihi?: Date;
    sicilKodu?: number;
    unvani?: string;
    adi?: string;
    soyadi?: string;
    babaAdi?: string;
    anneAdi?: string;
    dogumYeri?: string;
    cinsiyeti?: string;
    medeniDurumu?: string;
    dini?: string;
    kayitliOlduguYer?: string;
    mahalleKoy?: string;
    ciltNo?: string;
    aileSiraNo?: string;
    siraNo?: string;
    cepTelefonu: number;
    sabitTelefon?: number;
    ePosta?: string;
    ilIlceKodu: string;
    mahalleKodu?: number;
    mahalleAdi: string;
    caddeSokakKodu?: number;
    caddeSokakAdi: string;
    kapiNo: string;
    daireNo: string;
    siteApartmanAdi?: string;
    blokNo?: string;
    postaKodu?: number;
    smsBilgilendirme?: string;
    mailBilgilendirme?: string;
    kullanciKodu: string;
    sifre: string;
    hatirlatmaSorusuKodu: string;
    hatirlatmaCevabi: string;
    cuzdanSiraNo?: string;
    cuzdanSeriNo?: string;
    cuzdanVerilmeTarihi?: Date;
    durumBilgi?: string;

    constructor(
        uyelikTipi: number,
        cepTelefonu: number,
        ilIlceKodu: string,
        mahalleAdi: string,
        caddeSokakAdi: string,
        kapiNo: string,
        daireNo: string,
        kullanciKodu: string,
        sifre: string,
        hatirlatmaSorusuKodu: string,
        hatirlatmaCevabi: string,
        uyrukKodu?: string,
        uyelikKodu?: string,
        tcKimlikNo?: string,
        vergiNo?: string,
        vergiDairesiAdi?: string,
        dogumTarihi?: Date,
        sicilKodu?: number,
        unvani?: string,
        adi?: string,
        soyadi?: string,
        babaAdi?: string,
        anneAdi?: string,
        dogumYeri?: string,
        cinsiyeti?: string,
        medeniDurumu?: string,
        dini?: string,
        kayitliOlduguYer?: string,
        mahalleKoy?: string,
        ciltNo?: string,
        aileSiraNo?: string,
        siraNo?: string,
        sabitTelefon?: number,
        ePosta?: string,
        mahalleKodu?: number,
        caddeSokakKodu?: number,
        siteApartmanAdi?: string,
        blokNo?: string,
        postaKodu?: number,
        smsBilgilendirme?: string,
        mailBilgilendirme?: string,
        cuzdanSiraNo?: string,
        cuzdanSeriNo?: string,
        cuzdanVerilmeTarihi?: Date,
        durumBilgi?: string
    ) {
        this.uyelikTipi = uyelikTipi;
        this.cepTelefonu = cepTelefonu;
        this.ilIlceKodu = ilIlceKodu;
        this.mahalleAdi = mahalleAdi;
        this.caddeSokakAdi = caddeSokakAdi;
        this.kapiNo = kapiNo;
        this.daireNo = daireNo;
        this.kullanciKodu = kullanciKodu;
        this.sifre = sifre;
        this.hatirlatmaSorusuKodu = hatirlatmaSorusuKodu;
        this.hatirlatmaCevabi = hatirlatmaCevabi;
        this.uyrukKodu = uyrukKodu;
        this.uyelikKodu = uyelikKodu;
        this.tcKimlikNo = tcKimlikNo;
        this.vergiNo = vergiNo;
        this.vergiDairesiAdi = vergiDairesiAdi;
        this.dogumTarihi = dogumTarihi;
        this.sicilKodu = sicilKodu;
        this.unvani = unvani;
        this.adi = adi;
        this.soyadi = soyadi;
        this.babaAdi = babaAdi;
        this.anneAdi = anneAdi;
        this.dogumYeri = dogumYeri;
        this.cinsiyeti = cinsiyeti;
        this.medeniDurumu = medeniDurumu;
        this.dini = dini;
        this.kayitliOlduguYer = kayitliOlduguYer;
        this.mahalleKoy = mahalleKoy;
        this.ciltNo = ciltNo;
        this.aileSiraNo = aileSiraNo;
        this.siraNo = siraNo;
        this.sabitTelefon = sabitTelefon;
        this.ePosta = ePosta;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.siteApartmanAdi = siteApartmanAdi;
        this.blokNo = blokNo;
        this.postaKodu = postaKodu;
        this.smsBilgilendirme = smsBilgilendirme;
        this.mailBilgilendirme = mailBilgilendirme;
        this.cuzdanSiraNo = cuzdanSiraNo;
        this.cuzdanSeriNo = cuzdanSeriNo;
        this.cuzdanVerilmeTarihi = cuzdanVerilmeTarihi;
        this.durumBilgi = durumBilgi;
    }
}
export { KisiUyelikSaveRequest}